import { exportGroupNames } from '../dashboard/fragment/export/ExportCompetitorGroups';
import React from 'react';
import ExportFiltersTooltip
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/tooltip/ExportFiltersTooltip';

interface FiltersCellProps {
    filter: any;
    exportId: number;
    competitorTags: { id?: number, name: string }[];
}

function getFiltersDetails(filter: any, competitorTags: { id?: number, name: string }[]): string {
    if (!filter) return "";
    return Object.entries(filter)
        .filter(([_, v]) => {
            if (Array.isArray(v)) {
                return v.length > 0;
            }
            return v !== null && v !== undefined && v !== "";
        })
        .map(([k, v]) => {
            if (k === 'competitorTagIds') return `groups: [${exportGroupNames(v as number[], competitorTags).join(', ')}]`;
            if (Array.isArray(v)) {
                return `${k}: [${v.join(", ")}]`;
            }
            return `${k}: ${v}`;
        })
        .join(", ");
}

const FiltersCell: React.FC<FiltersCellProps> = ({ filter, exportId, competitorTags }) => {
    const details = getFiltersDetails(filter, competitorTags);

    return (
        <td className="whitespace-nowrap px-2 py-3 text-sm">
            {/* The anchor element for the tooltip. */}
            <div
                data-tooltip-id={`filters-tooltip-${exportId}`}
                className="cursor-pointer text-center w-[40px] bg-gray-100 rounded py-1"
            >
                {details ? details.split(",").length : 0}
            </div>
            {/* Render the custom tooltip */}
            <ExportFiltersTooltip id={`filters-tooltip-${exportId}`} details={details} />
        </td>
    );
};

export default FiltersCell;